const OFFER_GEO_URL = '/offer-geo';

export function offerGeoApi(offerGeoId?: string) {
  if (offerGeoId) {
    return `${OFFER_GEO_URL}/${offerGeoId}`;
  }

  return OFFER_GEO_URL;
}

export function offerGeoCountriesApi() {
  return `${OFFER_GEO_URL}/countries`;
}

export function countryStatisticsApi() {
  return `${offerGeoCountriesApi()}/statistic`;
}

export function applyOfferGeoProposedBid(offerGeoId?: string) {
  return `${offerGeoApi(offerGeoId)}/apply-proposed-bid`;
}
